import { css } from 'lit';
export default css `
    :host {
        display: contents;
    }

    .list {
        margin: 0;
        padding: 0;
    }
`;
